import { progressReportDateForInput } from "./progressReportUtils";

function plainSubdoc(obj) {
  if (obj == null) return {};
  if (typeof obj.toObject === "function") return obj.toObject();
  return { ...(typeof obj === "object" ? obj : {}) };
}

/** Build API payload for one edited report row vs its baseline. */
export function buildProgressReportSavePayload(row, baseline, trade) {
  if (!trade?._id || !baseline) return null;
  const ptPrev = plainSubdoc(trade.progressTracker);
  const progressTracker = { ...ptPrev };
  let ptChanged = false;

  const rowToPt = {
    action: "action",
    notes: "notes",
    tradeCategory: "progressReportTradeCategory",
    compliance: "progressReportCompliance",
  };
  for (const [rowKey, ptKey] of Object.entries(rowToPt)) {
    const a = String(row[rowKey] ?? "").trim();
    const b = String(baseline[rowKey] ?? "").trim();
    if (a !== b) {
      progressTracker[ptKey] = row[rowKey] ?? "";
      ptChanged = true;
    }
  }

  const followA = progressReportDateForInput(row.followUpDate);
  const followB = progressReportDateForInput(baseline.followUpDate);
  if (followA !== followB) {
    progressTracker.followUpDate = followA || "";
    ptChanged = true;
  }

  const invoiceA = progressReportDateForInput(row.invoiceDate);
  const invoiceB = progressReportDateForInput(baseline.invoiceDate);
  if (invoiceA !== invoiceB) {
    progressTracker.invoicedDate = invoiceA || "";
    ptChanged = true;
  }

  if (!ptChanged) return null;
  return { progressTracker };
}

export function getDirtyProgressReportRows(rows, baselineRows) {
  const baselineByKey = new Map(
    (baselineRows || []).map((r) => [r.rowKey, r]),
  );
  return (rows || []).filter((row) => {
    const base = baselineByKey.get(row.rowKey);
    if (!base) return true;
    return PROGRESS_REPORT_ROW_KEYS.some(
      (k) => String(row[k] ?? "").trim() !== String(base[k] ?? "").trim(),
    );
  });
}

const PROGRESS_REPORT_ROW_KEYS = [
  "tradeCategory",
  "compliance",
  "action",
  "followUpDate",
  "invoiceDate",
  "notes",
];

/** Persist all dirty rows; returns count of rows actually written. */
export async function saveProgressReportRows(
  rows,
  baselineRows,
  trades,
  axiosInstance,
) {
  const tradeById = new Map((trades || []).map((t) => [String(t._id), t]));
  const baselineByKey = new Map(
    (baselineRows || []).map((r) => [r.rowKey, r]),
  );
  const dirty = getDirtyProgressReportRows(rows, baselineRows);
  let savedCount = 0;

  for (const row of dirty) {
    const trade = tradeById.get(String(row.tradeId));
    const baseline = baselineByKey.get(row.rowKey);
    const payload = buildProgressReportSavePayload(row, baseline, trade);
    if (!payload) continue;

    await axiosInstance.patch(`/trades/${row.tradeId}/progress-report`, payload);
    savedCount += 1;
  }

  return { dirtyCount: dirty.length, savedCount };
}
